import React from 'react';
import { Select, Input, Button, Typography, Space } from "antd";
import { SearchOutlined, FilterOutlined } from '@ant-design/icons';

const { Text } = Typography;

const FilterControls = ({ 
  selectedBrand, 
  setSelectedBrand, 
  searchCity, 
  setSearchCity, 
  fetchData,
  topCities = [] 
}) => {
  // Brand options
  const brandOptions = [
    { value: '1', label: 'Nutrinova' },
    { value: '2', label: 'Max Vital' },
    { value: '3', label: 'Gold Pharma' },
  ];

  // Generate city options from top cities
  const cityOptions = topCities.map(city => ({
    value: city.city,
    label: `${city.city}, ${city.state} (${city.customer_count} customers)`
  }));

  return (
    <Space size="middle" wrap>
      {/* <div>
        <Text type="secondary" style={{ marginRight: 8 }}>Brand:</Text>
        <Select
          placeholder="Select Brand"
          style={{ width: 150 }}
          value={selectedBrand || undefined}
          onChange={value => setSelectedBrand(value)}
          allowClear
          options={brandOptions}
        />
      </div>
      
      <div>
        <Text type="secondary" style={{ marginRight: 8 }}>City:</Text>
        {cityOptions.length > 0 ? (
          <Select
            placeholder="Select Popular City"
            style={{ width: 220 }}
            showSearch
            value={searchCity || undefined}
            onChange={value => setSearchCity(value)}
            allowClear
            filterOption={(input, option) =>
              option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            options={cityOptions}
          />
        ) : (
          <Input
            placeholder="Search by city name"
            style={{ width: 180 }}
            value={searchCity}
            onChange={e => setSearchCity(e.target.value)}
            prefix={<SearchOutlined />}
            allowClear
          />
        )}
      </div>
      
      <Button 
        type="primary" 
        icon={<FilterOutlined />}
        onClick={fetchData}
      >
        Apply Filters
      </Button> */}
    </Space>
  );
};

export default FilterControls;
